import { hideHeaderOverlay, showHeaderOverlay } from '../tools/overlay'
import { checkResolution } from '../tools/helpers'
import '../../lib/js/jquery.menu-aim.js'

const navigation = document.querySelector('.js-navigation')
navigation.firstOpenTimeout = null
navigation.afterCloseTimeout = null
navigation.openReady = false

const onNavTabOpen = () => {
    if (checkResolution('sm;md;lg')) {
        showHeaderOverlay('nav')
    }
}

const onNavTabClose = () => {
    requestAnimationFrame(() => {
        if (checkResolution('sm;md;lg') && (!navigation.activeTabs || !navigation.activeTabs.length)) {
            hideHeaderOverlay('nav')
        }
    })
}

navigation.addEventListener('rTab.after.openTab', (event) => {
    navigation.openReady = true
    onNavTabOpen()
})

navigation.addEventListener('rTab.handleTrigger', (event) => {
    if (checkResolution('sm;md;lg') && event.detail.activeTabs.length) {
        event.preventDefault()
    }
})

navigation.addEventListener('rTab.after.closeAllTabs', onNavTabClose)
navigation.addEventListener('rTab.after.closeTab', (event) => {
    clearTimeout(navigation.afterCloseTimeout)
    onNavTabClose()

    // after closing, do not delay next opening in case you accidentally closed it
    navigation.afterCloseTimeout = setTimeout(() => {
        navigation.openReady = false
    }, 200)
})

navigation.addEventListener('mouseleave', (event) => {
    if (!navigation.activeTabs || !navigation.activeTabs.length) {
        return
    }

    clearTimeout(navigation.afterCloseTimeout)

    navigation.closeAllTabs()
    navigation.openReady = false
})

navigation.addEventListener('mouseover', (event) => {
    clearTimeout(navigation.afterCloseTimeout)
})

$('.js-navigation-main').menuAim({
    enter(row) {
        clearTimeout(navigation.afterCloseTimeout)

        // do not delay hover if tabs are open
        if (navigation.activeTabs && navigation.activeTabs.length) {
            return
        }

        // if you hover over trigger, delay opening in case you leave trigger immediately
        navigation.firstOpenTimeout = setTimeout(() => {
            navigation.openReady = true
            this.activate(row)
        }, 100)
    },
    exit() {
        clearTimeout(navigation.firstOpenTimeout)

        navigation.afterCloseTimeout = setTimeout(() => {
            navigation.closeAllTabs()
            navigation.openReady = false
        }, 200)
    },
    activate(row) {
        if (!navigation.openReady || typeof navigation.openTab !== 'function' || !checkResolution('sm;md;lg')) {
            return
        }

        clearTimeout(navigation.afterCloseTimeout)
        navigation.openTab(row.dataset.tabId)
    },
    deactivate(row) {
        if (typeof navigation.closeTab !== 'function' || !navigation.activeTabs.length || !checkResolution('sm;md;lg')) {
            return
        }

        navigation.closeTab(row.dataset.tabId)
    },
    rowSelector: '.js-navigation-item',
    submenuDirection: 'below'
})